import { normalizeRoleSlug } from "../../../public/utils/roleAccess";

const OFFICE_SLUGS = new Set(["office"]);
const RECEPTION_SLUGS = new Set([
  "receptionist",
  "recep",
  "reception",
  "front-desk",
  "frontdesk",
]);

export function isOfficeRoleSlug(role) {
  return OFFICE_SLUGS.has(normalizeRoleSlug(role));
}

export function isReceptionRoleSlug(role) {
  return RECEPTION_SLUGS.has(normalizeRoleSlug(role));
}
